import { AmplitudeEvents } from 'core/constants/AmplitudeEvents';
import { ApiStage } from 'core/constants/enums/ApiStages.ts';
import { RendernetErrors } from 'core/constants/enums/RendernetErrors.ts';
import { ToastType } from 'core/constants/enums/ToastTypeEnum.ts';
import { PostHogEvents } from 'core/constants/PostHogEvents';
import { sendToast } from 'core/layouts/components/toast/ToastUtils';
import { createNewCharacterAsync } from 'core/store/reducers/characterStudioReducer/CreateNewCharacterSliceThunk';
import { captureAmplitudeEvent } from 'core/utils/AmplitudeUtils.ts';
import { capturePosthogEvent } from 'core/utils/PosthogUtil.ts';
/* eslint-disable no-param-reassign */
export const createNewCharacterExtraReducers = (builder) => {
	builder.addCase(createNewCharacterAsync.pending, (state) => {
		state.isCharacterCreationInProgress = true;
		state.characterCreationApiStage = ApiStage.LOADING;
	});
	builder.addCase(createNewCharacterAsync.fulfilled, (state) => {
		state.isCharacterCreationInProgress = false;
		state.characterCreationApiStage = ApiStage.SUCCESS;
	});
	builder.addCase(createNewCharacterAsync.rejected, (state, action) => {
		const { error } = action;
		state.isCharacterCreationInProgress = false;
		state.characterCreationApiStage = ApiStage.ERROR;
		if (error.code === RendernetErrors.NSFW_PROMPT) {
			captureAmplitudeEvent(AmplitudeEvents.NSFW_TOAST);
			capturePosthogEvent(PostHogEvents.NSFW_TOAST);
			sendToast(ToastType.NSFW_CHARACTER_PROMPT_DESCRIPTION);
		} else {
			sendToast(ToastType[error.code] ?? ToastType.DEFAULT_SOMETHING_WENT_WRONG_TRY_AGAIN);
		}
	});
};

export const createNewCharacterReducers = {
	resetCharacterCreationReferenceImage: (state) => {
		state.characterCreationReferenceImage = null;
	},
	setCharacterCreationReferenceImage: (state, action) => {
		state.characterCreationReferenceImage = action.payload;
	},
};

export const characterCreationApiStageSelector = (state) =>
	state.characterStudio.characterCreationApiStage;

/* eslint-enable no-param-reassign */
